import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';
import { Pager, useProgress } from '@hugendubel/react-basic';
import { Store } from '../../../store';
import { BonusPoints } from '../../BonusPoints';
import { SearchService } from '../../../services/search-service';
import { ArticleList } from './ArticleList';
import { PageableList } from '@hugendubel/ws_client';
import { ReducedProduct } from '../../../ws/result/ReducedProduct';

type ArticleLoaderStoreProps = { points: BonusPoints; articles: PageableList<ReducedProduct> | null };
type ArticleLoaderOwnProps = Record<string, unknown>;
export type ArticleLoaderProps = ArticleLoaderStoreProps & ArticleLoaderOwnProps;

export const UnconnectedArticleLoader: React.FC<ArticleLoaderProps> = ({ points: { value }, articles }) => {
    const [loading, withProgress] = useProgress();
    const { search } = useLocation();
    const searchId = useMemo(() => SearchService.getSearchId(search), [search]);
    const results = articles?.results || 0;

    useEffect(() => {
        withProgress(() => SearchService.loadArticles(value));
    }, [value, searchId, withProgress]);

    return loading ? (
        <div className="row article-list area-spinner" />
    ) : (
        <>
            <Pager results={results} pagingAmount={SearchService.DEFAULT_MAX_RESULTS} />
            <ArticleList />
            <Pager results={results} pagingAmount={SearchService.DEFAULT_MAX_RESULTS} />
        </>
    );
};

export const ArticleLoader = Store.wire<ArticleLoaderStoreProps, ArticleLoaderOwnProps>(
    UnconnectedArticleLoader,
    ({ points, articles }) => ({ points, articles })
);
